var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_eye",
    "data-name": "vuesax/bold/eye",
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.25,5.72C16.94,2.09,13.56,0,10,0A9.682,9.682,0,0,0,4.91,1.49,13.354,13.354,0,0,0,.75,5.72a5.771,5.771,0,0,0,0,5.69c2.31,3.64,5.69,5.72,9.25,5.72a9.682,9.682,0,0,0,5.09-1.49,13.354,13.354,0,0,0,4.16-4.23A5.771,5.771,0,0,0,19.25,5.72ZM10,12.61a4.04,4.04,0,1,1,4.04-4.04A4.035,4.035,0,0,1,10,12.61Z",
    transform: "translate(110 191.43)",
    fill: "#1f143d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.85,0A2.855,2.855,0,1,0,5.71,2.86,2.857,2.857,0,0,0,2.85,0Z",
    transform: "translate(117.15 197.14)",
    fill: "#1f143d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(132 212) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eyeBlack.7826ffd664d770ffd34feb19a5481528.svg";
export { ForwardRef as ReactComponent };